import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import QuizIcon from '@mui/icons-material/Quiz';
import ModuleAssessmentsListPanel from './ModuleAssessmentsListPanel';

export default function ModuleAssessmentsTab({
  qualificationId,
  module,
  onAssessmentsChanged,
  parentAssessmentListVersion,
  onOpenTaskAssessmentWizard
}) {
  return (
    <Box>
      <Stack direction="row" spacing={2} sx={{ mb: 2 }} alignItems="center" flexWrap="wrap" useFlexGap>
        <Button variant="contained" startIcon={<QuizIcon />} onClick={onOpenTaskAssessmentWizard}>
          New task assessment
        </Button>
      </Stack>
      <ModuleAssessmentsListPanel
        qualificationId={qualificationId}
        module={module}
        parentAssessmentListVersion={parentAssessmentListVersion}
        onAssessmentsChanged={onAssessmentsChanged}
      />
    </Box>
  );
}
